import { useEffect } from "react";
import { getActiveSite } from "@/api/client";
import { useDashboard } from "@/context/DashboardContext";
import { consumeAssistantPending, executeAssistantUiActions, queueAssistantPending } from "./assistantExecutor";
import type { AssistantContext, AssistantUiAction } from "./types";
import { normalizeAssistantTab } from "./types";

export default function AssistantBridge() {
  const { activeTab, setActiveTab, activeSite, user } = useDashboard();

  useEffect(() => {
    window.__CREA_ASSISTANT_EXECUTE__ = (actions: unknown[]) => {
      executeAssistantUiActions(actions, setActiveTab);
    };
    const leftover = consumeAssistantPending();
    if (leftover.length) queueAssistantPending(leftover);
    return () => {
      delete window.__CREA_ASSISTANT_EXECUTE__;
    };
  }, [setActiveTab]);

  useEffect(() => {
    window.__CREA_ASSISTANT_CONTEXT__ = () => ({
      surface: "dashboard",
      tab: activeTab,
      domain: activeSite || getActiveSite() || "",
      hash: typeof location !== "undefined" ? location.hash : "",
      path: typeof location !== "undefined" ? location.pathname : "",
      userEmail: user?.email ? String(user.email) : "",
      userRole: user?.role ? String(user.role) : "user",
      isAdministrator: Boolean(user?.isAdministrator),
      selectedLeadId: null
    });
    return () => {
      delete window.__CREA_ASSISTANT_CONTEXT__;
    };
  }, [activeTab, activeSite, user]);

  return null;
}

export function runAssistantActionsFromChat(
  actions: unknown[],
  setActiveTab: (tab: import("@/types/dashboard").DashboardTab) => void
): AssistantUiAction[] {
  const { tables } = executeAssistantUiActions(actions, setActiveTab);
  return tables;
}

export { normalizeAssistantTab };
